<template>
    <div :class="classObj">
        <select
            v-disabled-change
            @focus="addFocusClass()"
            @blur="removeFocusClass()"
            @change="changeSelectedLabel()"
            @disabled-change="onDisabledChange($event)"
            :id="$props.id"
            :name="$props.name"
            :required="$props.required"
            class="shared-select__select"
            ref="selectElem"
        >
            <option value="">{{ $props.placeholder.toUpperCase() }}</option>
            <slot></slot>
        </select>

        <span v-if="selectedValue == '' || selectedLabel !== placeholder" aria-hidden="true">{{ selectedLabel }}</span>
        <span v-else aria-hidden="true">{{ selectedValue }}</span>
        <span aria-hidden="true" class="shared-select__icon icon_type_dropdown ico-down"></span>
    </div>
</template>

<script>
import { AttributeChangeDirective } from '../../directives/attribute-change';

export default {
    directives: {
        'disabled-change': AttributeChangeDirective('disabled', 'disabled-change'),
    },
    data() {
        return {
            focusRecieved: false,
            disabled: false,
            selectedLabel: '',
        };
    },
    props: {
        error: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            required: true,
        },
        id: String,
        name: String,
        required: Boolean,
        selectedValue: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        addFocusClass() {
            this.focusRecieved = true;
        },
        removeFocusClass() {
            this.focusRecieved = false;
        },
        changeSelectedLabel() {
            const { options, selectedIndex } = this.$refs.selectElem
            this.selectedLabel = options[selectedIndex].innerText;
        },
        onDisabledChange({ target }) {
            this.disabled = target.disabled;
        },
    },
    computed: {
        classObj() {
            return {
                'shared-select': true,
                'shared-select_error': this.$props.error,
                'shared-select_focus': this.focusRecieved,
                'shared-select_disabled': this.disabled,
            };
        },
    },
    mounted() {
        this.changeSelectedLabel();
    }
};
</script>
